import axios from '@/config/axios'


/**
 * 分页列表
 * @param query 过滤条件
 */
export const vendorList = (query) => axios.get(`/v1/api/mg/vendors`, {params: query})


/**
 * 更新
 * @param vendor
 * @returns {IDBRequest | Promise<void>}
 */
export const vendorUpdate = (vendor) => axios.put(`/v1/api/mg/vendors/${vendor.id}`, vendor)

/**
 * 查看
 * @param id
 * @returns {IDBRequest | Promise<void>}
 */
export const vendor = (id) => axios.get(`/v1/api/mg/vendors/${id}`)

/**
 * 查看
 * @param id
 * @param status 状态
 * @returns {IDBRequest | Promise<void>}
 */
export const vendorAudit = (id, status) => axios.get(`/v1/api/mg/vendors/${id}/audit?status=${status}`)

/**
 * 查看服务商提交的文件列表
 * @param id
 * @returns {IDBRequest | Promise<void>}
 */
export const vendorFile = (id) => axios.get(`/v1/api/mg/vendors/${id}/files`)


/**
 * 服务商服务列表
 * @param id
 * @returns {AxiosPromise<any>}
 */
export const vendorServiceList = (id) => axios.get(`/v1/api/mg/vendors/${id}/services`)


const advVendorBase = '/v1/api/mg/ad/vendors'


/**
 * 分页列表
 * @param query 当前页
 */
export const adVendorList = (query) => axios.get(`${advVendorBase}`, {params: query})
/**
 * 更新
 * @param vendor
 * @returns {IDBRequest | Promise<void>}
 */
export const adVendorUpdate = (vendor) => axios.put(`${advVendorBase}/${vendor.id}`, vendor)


/**
 * 新增
 * @param vendor
 * @returns {IDBRequest | Promise<void>}
 */
export const adVendorCreate = (vendor) => axios.post(`${advVendorBase}`, vendor)


/**
 * 查看
 * @param id
 * @returns {IDBRequest | Promise<void>}
 */
export const forbidVendor = (id) => axios.get(`/v1/api/mg/ad/vendors${id}`)


const priceBase = '/v1/api/mg/vendorPrice'


/**
 * 价格列表
 * @param query 查询条件
 * @returns {AxiosPromise<any>}
 */
export const priceList = (query) => axios.get(`${priceBase}`, {
    params: query
})

export const priceUpdate = (data) => axios.put(`${priceBase}/${data.id}`, data)


export const priceCreate = (data) => axios.post(`${priceBase}`, data)


/**
 * 商户登录
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const vendorLogin = (data) => axios.post("/v1/api/mg/vendorAuth", data)


const employeesBase = '/v1/api/mg/vendorEmployee';

/*
* 雇员列表
* @param query 查询条件
* @returns {AxiosPromise<any>}
*/
export const employeesList = (query) => axios.get(`${employeesBase}`, {
    params: query
})
/**
 * 新增雇员
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const employeeCreate = (data) => axios.post(`${employeesBase}`, data)
/**
 * 更新雇员
 * @param data
 * @returns {AxiosPromise<any>}
 */
export const employeeUpdate = (data) => axios.put(`${employeesBase}/${data.id}`, data)


export const employeeUpdateStatus = (id) => axios.patch(`${employeesBase}/${id}`)

export const deleteEmployee = (id) => axios.delete(`${employeesBase}/${id}`)
